import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Anchor, Label, Wrapper } from '../Select/_styles'
import Arrow from 'components/Common/MasterComponents/Select/Arrow'
import DefaultTooltip from 'components/Common/Tooltips/DefaultTooltip'

const Button = styled(Anchor)`
  :hover {
    box-shadow: none;
  }
`

const TooltipText = styled.div`
  max-width: 200px;
`

const NotAvailable = () => {
  const { t } = useTranslation()
  return (
    <DefaultTooltip
      placement='bottom'
      offset={12}
      tooltip={
        <TooltipText>
          {t('wine.view.shareOptions.notEnoughtInformation')}
        </TooltipText>
      }
    >
      <Wrapper>
        <Button>
          <Label>{t('wine.view.techsheet.viewPdf')}</Label>
          <Arrow />
        </Button>
      </Wrapper>
    </DefaultTooltip>
  )
}

export default memo(NotAvailable)
